// TODO: write constants in english

export const MINUTE_IN_SECONDS = 60
export const HOUR_IN_SECONDS = MINUTE_IN_SECONDS * 60
export const DAY_IN_SECONDS = HOUR_IN_SECONDS * 24
export const MONTH_IN_SECONDS = 2629800

export const YEAR_IN_SECONDS = 31557600
export const YEAR_IN_DAYS = 365
